import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { Fragment } from "react";
import Lottie from "react-lottie";
import { Collage } from "../components/Sections";
import { layout } from "../components/Layout";

export default function DigitalMarketing() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="anigrad">
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                marginTop: state.auth.isMobile
                  ? state.auth.isTablet
                    ? "-300px"
                    : "-135px"
                  : "0px",
                fontSize: state.auth.isMobile ? "25px" : "6vh",
                color: "white",
                zIndex: 999,
                textAlign: "left",
                marginBottom: "25px",
                fontWeight: "bold",
                width: state.auth.isMobile ? "92vw" : "90vw",
                maxWidth: "1140px",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  fontSize: layout.heading2[state.auth.view],
                  lineHeight: state.auth.isMobile ? 1.2 : 1.25,
                  overflowWrap: "break-word",
                }}
              >
                Data-Driven Digital Marketing Services
                <br />
                <span style={{ color: "yellow" }}>
                  That Drive Real Business Growth
                </span>
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "24px" : "4.4vh",
                  lineHeight: state.auth.isMobile ? 1.3 : 1.2,
                  color: "white",
                  zIndex: 999,
                }}
              >
                Unlocking the power of digital to connect, engage, and convert
                your audience.
              </div>
            </div>
          </div>
        </div>
        <Stats />
        {state.auth.isTablet ? (
          <SpacerV height={"300px"} background="#111" />
        ) : (
          ""
        )}
        <ContentSideBySideInv
          title={<h2>Key Benefits of Digital Marketing Solutions for Business</h2>}
          subtitle={
            <div>
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                Targeted audience reach.
              </div>
              Artificial Intelligence (AI) and Machine Learning (ML) speed up
              Measurable results through analytics. making better decisions.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Measurable results through analytics.
              </div>
              Prevent human errors and ensure accurate results with the help of
              Artificial Intelligence in your processes.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                Cost-effective compared to traditional marketing methods.
              </div>
              Machine learning can be used to streamline corporate processes and
              help find anomalies in them to boost efficiency.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/work.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        {!state.auth.isMobile ? (
          <SpacerV height={"100px"} background="white" />
        ) : (
          ""
        )}

        <SpacerV height={"6vh"} background="white" />

        <ContentSideBySide
          title={<h2>Potential with AI-Powered Google and Meta Ads"</h2>}
          subtitle={
            "Harness the power of Artificial Intelligence (AI) in lead generation through Google and Meta ads. Discover how advanced algorithms analyze user behavior, preferences, and intent to precisely target your audience. With Google and Meta ads, you can maximize your return on investment (ROI) by reaching potential customers at the right moment with the right message. Let AI-driven ad campaigns propel your business forward, generating high-quality leads and increasing conversions effortlessly."
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/graph2.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <SpacerV height={"100px"} background="white" />
        {!state.auth.isMobile ? (
          <SpacerV height={"100px"} background="white" />
        ) : (
          ""
        )}

        <SpacerV height={"6vh"} background="white" />

        <ThreeSideBySide
          hero={"What Digital Marketing Services Do We Offer"}
          background={
            "linear-gradient(135deg, #ab4459 0%, #00498d 25%, #441752 75%, #1b1833 100%)"
          }
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"55vh"}
                title={"Ad Operations"}
                text={`Leverage our extensive ad server expertise to amplify your sales
                team’s efforts. We offer tailored campaign management, whether
                you need us on a full-time basis or for specific tasks. Expect
                prepared reports and detailed campaign screenshots to monitor
                your progress.`}
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"55vh"}
                title={"Search Media Management"}
                text={`Social Media Management involves creating, scheduling,
              analyzing, and engaging with content posted on social media
              platforms such as Facebook, Instagram, and Twitter. It aims to
              build and maintain a brand’s online presence, foster community
              engagement, and drive website traffic and conversions`}
                icon={
                  <TabIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"55vh"}
                title={"Programmatic Ads"}
                text={` Programmatic advertising automates the process of buying and
                selling digital ad inventory in real-time through algorithms and
                data-driven technology. It enables precise targeting, efficient
                spending, and optimization, delivering ads to the
                right audience at the right time and place.`}
                icon={
                  <DvrIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"55vh"}
                title={"Search Engine Optimization"}
                text={`Search Engine Optimization (SEO) is the process of optimizing a
              website to improve its visibility in search engine results pages
              (SERPs). By enhancing factors like content quality, keywords,
              and website structure, SEO aims to increase organic traffic and
              improve site rankings for relevant searches.`}
                icon={
                  <BlurOnIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"55vh"}
                title={" Pay Per Click"}
                text={` Pay Per Click (PPC) advertising is a digital marketing model
                where advertisers pay a fee each time their ad is clicked. It’s
                an efficient way to drive targeted traffic to websites, offering
                instant visibility and control over ad spend, with performance
                easily measurable through analytics.`}
                icon={
                  <WindowIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"55vh"}
                title={" Conversion Rate Optimization"}
                text={`Conversion Rate Optimization (CRO) is the process of improving
              the percentage of website visitors who complete a desired
              action, such as making a purchase or filling out a form. It
              involves analyzing user behavior, testing different elements,
              and optimizing the website to maximize conversions `}
                icon={
                  <DoubleArrowIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />

        <Stats />
        <SpacerV height={"100px"} background="#111" />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
